module.exports = __webpack_public_path__ + "img/p5-info.825f962d.jpg";